/**
 * Facility Filter Component
 * Multi-tenant facility selection with timezone display
 */

import { Select } from 'antd';
import { useAppSelector, useAppDispatch } from '../../../store/hooks';
import { setFilters } from '../../../store/dashboardSlice';
import { setSelectedFacility } from '../../../store/facilitiesSlice';
import type { Facility } from '../../../store/facilitiesSlice';

const { Option } = Select;

interface FacilityFilterProps {
  facilities: Facility[];
  className?: string;
}

function FacilityFilter({ facilities, className }: FacilityFilterProps) {
  const dispatch = useAppDispatch();
  const selectedFacilityId = useAppSelector(state => state.dashboard.filters.facilityId);

  const handleFacilityChange = (value: number | string | null | undefined) => {
    // Convert "all" string to null, keep numbers as-is
    const facilityId = value === "all" || value === undefined ? null : (value as number);

    // Update both the global facilities slice and dashboard slice
    // This prevents the sync effect from overwriting the user's selection
    dispatch(setSelectedFacility(facilityId));
    dispatch(setFilters({ facilityId }));
  };

  return (
    <div className={`filter ${className || ''}`} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <label htmlFor="facility-select">Facility:</label>
      <Select
        id="facility-select"
        value={selectedFacilityId === null ? "all" : selectedFacilityId}
        placeholder="Select facility"
        onChange={handleFacilityChange}
        style={{ width: '300px' }}
        allowClear
      >
        <Option key="all" value="all">
          All Facilities
        </Option>
        {facilities.map((facility) => (
          <Option key={facility.id} value={facility.id}>
            {facility.name} {facility.offset ? `(UTC${facility.offset})` : ''}
          </Option>
        ))}
      </Select>
    </div>
  );
}

export default FacilityFilter;